/* Traduzioni per operatori (dipendente/rider) e per la Scheda Giornaliera stampabile.
 * Lingue: it (Italiano), en (English), ur (Urdu). */
export const LANG = {
  it: {
    dir: "ltr",
    locale: "it-IT",
    // -- Print sheet (SchedulePrintPage) --
    title: "Scheda giornaliera",
    for: "Per",
    date: "Data",
    cleanings: "Pulizie",
    deliveries: "Consegne",
    no_cleanings: "Nessuna pulizia oggi",
    no_deliveries: "Nessuna consegna oggi",
    structure: "Struttura",
    address: "Indirizzo",
    beds: "Letti",
    matr: "Matr.",
    matr1p: "Matr. 1p",
    sing: "Singoli",
    guests_arriving: "OSPITI IN ARRIVO",
    private_linen: "Biancheria privata",
    notes: "Note",
    listen: "Ascolta",
    stop_listen: "Stop",
    keybox: "Keybox",
    keys: "Chiavi",
    access: "Accesso",
    print: "Stampa",
    kg: "kg",
    signature: "Firma",
    daily_sheet_tag: "Scheda del giorno",
    guests_total: "ospiti totali",
    guests_short: "osp",
    guests_arriving_short: "Entrano",
    bathrooms: "Bagni",
    bathroom_unit: "bagno",
    extra: "extra",
    no_bed_change: "nessun cambio",
    parking: "Parcheggio",
    contact: "Contatto",
    floor: "piano",
    operator_signature: "Firma operatore",
    start_time: "Ora inizio",
    end_time: "Ora fine",
    done: "Fatta",
    unassigned: "Non assegnate",
    operator: "Operatore",
    cleanings_count: "pulizie",
    // -- App nav (bottom + sidebar) --
    nav_today: "Oggi",
    nav_cleanings: "Pulizie",
    nav_reports: "Segnalazioni",
    nav_profile: "Profilo",
    nav_kilo: "Kilo AI",
    nav_notifications: "Notifiche",
    nav_logistics: "Logistica",
    nav_logistics_structures: "Strutture",
    // -- Dashboard operatore --
    hello: "Ciao",
    kpi_assigned: "Assegnate",
    kpi_to_do: "Da iniziare",
    kpi_in_progress: "In corso",
    kpi_completed: "Completate",
    call_responsible: "Chiama responsabile",
    call_responsible_sub: "Per problemi o urgenze",
    today_cleanings: "Le pulizie di oggi",
    no_cleanings_today: "Nessuna pulizia oggi",
    no_cleanings_today_sub: "Riposati o controlla domani.",
    guest_one: "ospite",
    guest_many: "ospiti",
    bed_double: "matrimoniale",
    bed_double_1p: "matr. (1 pers)",
    bed_single: "singolo",
    // -- Cleaning detail --
    back: "Indietro",
    have_problem: "Hai un problema?",
    send_report: "Invia una segnalazione con foto",
    report_action: "Segnala →",
    info: "Informazioni",
    keys_position: "Posizione chiavi",
    beds_planned: "Letti previsti",
    contacts: "Contatti",
    access_notes: "Note accesso",
    kits_planned: "Kit previsti",
    linen_in_house: "Biancheria in casa",

    day_note: "Nota del giorno",
    fixed_note: "Nota fissa della casa",
    start_cleaning: "Inizia pulizia",
    complete_cleaning: "Completa pulizia",
    cleaning_completed: "Pulizia completata",
    kits_used: "Kit usati",
    signature_full_name: "Firma (nome e cognome)",
    signature_placeholder: "Es. Mario Rossi",
    final_notes: "Note finali",
    cancel: "Annulla",
    sending: "Invio…",
    confirm_completion: "Conferma completamento",
    keybox_missing_fallback: "Nessun codice keybox configurato — chiedi al responsabile.",
    keys_position_missing_fallback: "Posizione chiavi non configurata — chiedi al responsabile.",
    // -- Profile --
    my_profile: "Il mio profilo",
    logout: "Esci",
    email: "Email",
    role: "Ruolo",
    language: "Lingua",
    change_pin: "Cambia PIN",
    // -- Reports --
    reports_title: "Segnalazioni",
    new_report: "Nuova segnalazione",
    no_reports: "Nessuna segnalazione",
    // -- Notifications --
    notifications_title: "Notifiche",
    no_notifications: "Nessuna notifica",
    // -- Logistics --
    logistics_title: "Consegne di oggi",
    pickup: "Ritiro",
    delivery: "Consegna",
    both: "Ritiro+Consegna",
    // -- Common actions --
    save: "Salva",
    close: "Chiudi",
    refresh: "Aggiorna",
    // -- Le mie pulizie / lista --
    history: "Storico",
    my_cleanings: "Le mie pulizie",
    today: "Oggi",
    no_cleanings_list: "Nessuna pulizia",
    entering_today: "Entrano oggi",
    notes_label: "Note",
    completed: "Completata",
    open_and_complete: "Apri e completa",
    extra_products_hint: "Segnala prodotti extra trovati sporchi o usati oltre ai kit",
    kit_extra: "extra",
    // -- Nuova segnalazione --
    note: "Nota",
    photos_optional: "Foto (facoltative)",
    add_photo: "Aggiungi foto",
    uploading: "Caricamento…",
    send_report_btn: "Invia segnalazione",
    select_placeholder: "Seleziona…",
    describe_problem: "Descrivi il problema o quello che serve segnalare…",
    remove_photo: "Rimuovi foto",
    err_select_structure: "Seleziona una struttura",
    err_insert_note: "Inserisci una nota",
    err_wait_photos: "Attendi il caricamento delle foto",
    err_photo_upload: "Caricamento foto fallito",
    report_sent: "Segnalazione inviata",
    report_queued: "Sei offline: la segnalazione verrà inviata appena torni online.",
    // -- Liste segnalazioni / notifiche --
    no_reports_yet: "Nessuna segnalazione inviata",
    original_it: "Italiano",
    push_unsupported: "Questo dispositivo/browser non supporta le notifiche.",
    push_disable: "Disattiva su questo dispositivo",
    push_test: "Invia test",
    push_refresh_app: "Aggiorna app",
    push_title: "Notifiche push",
    push_sub: "Attiva per ricevere sul telefono ogni nuova assegnazione o segnalazione urgente.",
    push_blocked: "Notifiche bloccate dal browser. Vai nelle impostazioni del sito e riabilitale, poi riprova.",
    push_enable: "Attiva notifiche",
    push_active: "Notifiche attive su questo telefono.",
    role_dipendente: "Dipendente",
    role_responsabile: "Responsabile",
    role_rider: "Rider",
    phone: "Telefono",
    pin_hint: "Accesso rapido tramite PIN a 4 cifre. Per cambiare PIN chiedi al Super Admin.",
    lang_updated: "Lingua aggiornata",
    load_error: "Errore caricamento",
    no_upcoming_cleanings: "Nessuna pulizia assegnata per i prossimi giorni",
    upcoming_cleanings: "Prossime pulizie assegnate",
    your_reports: "Le tue segnalazioni",
    new_short: "Nuova",
    no_reports_hint: "Inviane una se noti un problema in struttura",
    st_aperta: "Aperta",
    st_in_lavorazione: "In lavorazione",
    st_risolta: "Risolta",
    st_chiusa: "Chiusa",
    updates: "Aggiornamenti",
    mark_all: "Segna tutte",
    all_marked_read: "Tutte segnate come lette",
    dev_title: "Segnalazioni e scostamenti dal kit",
    dev_help: "Puoi mandare solo una nota al responsabile (senza indicare pezzi), oppure segnalare un pezzo usato in più, non usato o da stornare. Il magazzino non viene toccato: decide il responsabile.",
    dev_item: "Articolo",
    dev_optional: "(facoltativo)",
    dev_no_item: "Nessun articolo: mando solo la nota",
    dev_what_happened: "Cosa è successo",
    dev_pieces: "Pezzi",
    dev_note_ph: "Nota per il responsabile (basta questa per inviare la segnalazione)",
    dev_add_row: "Aggiungi un'altra riga",
    dev_submit: "Segnala al responsabile",
    dev_err_empty: "Scrivi una nota oppure scegli un articolo",
    dev_sent: "Segnalato al responsabile",
    dev_queued: "Nessuna rete: la segnalazione parte appena torna il segnale",
    dev_k_usato_extra: "Pezzo usato in più",
    dev_k_non_usato: "Pezzo non usato",
    dev_k_storno: "Pezzo non conforme (macchiato/rovinato)",
    dev_k_nota: "Solo segnalazione (nessun pezzo)",
    dev_generic: "Segnalazione",
    dev_pz: "pz",
    dev_pending: "in attesa",
    dev_applied: "applicato",
    dev_ignored: "ignorato",
    st_da_fare: "Confermata",
    st_in_viaggio: "In viaggio",
    st_iniziata: "Iniziata",
    st_in_corso: "In corso",
    st_completata: "Completata",
    st_bloccata: "Bloccata",
    st_da_verificare: "Da verificare",
    tax_title: "Tassa di soggiorno",
    tax_help: "Se trovi contanti della tassa di soggiorno in appartamento, scrivi l'importo, fai la foto e dì se li hai lasciati lì o presi con te. Quando li porti in sede segnalo.",
    tax_amount: "Importo",
    tax_photo: "Foto dei contanti",
    tax_left_there: "Li ho lasciati lì",
    tax_taken: "Li ho presi con me",
    tax_delivered: "Consegnati in sede",
    tax_saved: "Registrato",
    tax_err_amount: "Scrivi l'importo trovato",
    tax_st_left: "in appartamento",
    tax_st_taken: "in mano all'addetta",
  },
  es: {
    dir: "ltr",
    locale: "es-ES",
    // -- Print sheet --
    title: "Hoja diaria",
    for: "Para",
    date: "Fecha",
    cleanings: "Limpiezas",
    deliveries: "Entregas",
    no_cleanings: "Ninguna limpieza hoy",
    no_deliveries: "Ninguna entrega hoy",
    structure: "Alojamiento",
    address: "Dirección",
    beds: "Camas",
    matr: "Matrim.",
    matr1p: "Matrim. 1p",
    sing: "Individuales",
    guests_arriving: "LLEGAN HUÉSPEDES",
    private_linen: "Ropa privada",
    notes: "Notas",
    listen: "Escuchar",
    stop_listen: "Parar",
    keybox: "Caja de llaves",
    keys: "Llaves",
    access: "Acceso",
    print: "Imprimir",
    kg: "kg",
    signature: "Firma",
    daily_sheet_tag: "Hoja del día",
    guests_total: "huéspedes en total",
    guests_short: "hué",
    guests_arriving_short: "Entran",
    bathrooms: "Baños",
    bathroom_unit: "baño",
    extra: "extra",
    no_bed_change: "sin cambio",
    parking: "Aparcamiento",
    contact: "Contacto",
    floor: "piso",
    operator_signature: "Firma del operario",
    start_time: "Hora de inicio",
    end_time: "Hora de fin",
    done: "Hecha",
    unassigned: "Sin asignar",
    operator: "Operario",
    cleanings_count: "limpiezas",
    // -- App nav --
    nav_today: "Hoy",
    nav_cleanings: "Limpiezas",
    nav_reports: "Incidencias",
    nav_profile: "Perfil",
    nav_kilo: "Kilo AI",
    nav_notifications: "Notificaciones",
    nav_logistics: "Logística",
    nav_logistics_structures: "Alojamientos",
    // -- Dashboard operatore --
    hello: "Hola",
    kpi_assigned: "Asignadas",
    kpi_to_do: "Por empezar",
    kpi_in_progress: "En curso",
    kpi_completed: "Completadas",
    call_responsible: "Llamar al responsable",
    call_responsible_sub: "Para problemas o urgencias",
    today_cleanings: "Las limpiezas de hoy",
    no_cleanings_today: "Ninguna limpieza hoy",
    no_cleanings_today_sub: "Descansa o revisa mañana.",
    guest_one: "huésped",
    guest_many: "huéspedes",
    bed_double: "matrimonial",
    bed_double_1p: "matrim. (1 pers)",
    bed_single: "individual",
    // -- Cleaning detail --
    back: "Atrás",
    have_problem: "¿Tienes un problema?",
    send_report: "Envía una incidencia con foto",
    report_action: "Reportar →",
    info: "Información",
    keys_position: "Ubicación de las llaves",
    beds_planned: "Camas previstas",
    contacts: "Contactos",
    access_notes: "Notas de acceso",
    kits_planned: "Kits previstos",
    linen_in_house: "Ropa en la casa",
    day_note: "Nota del día",
    fixed_note: "Nota fija de la casa",
    start_cleaning: "Empezar limpieza",
    complete_cleaning: "Completar limpieza",
    cleaning_completed: "Limpieza completada",
    kits_used: "Kits usados",
    signature_full_name: "Firma (nombre y apellido)",
    signature_placeholder: "Ej. Mario Rossi",
    final_notes: "Notas finales",
    cancel: "Cancelar",
    sending: "Enviando…",
    confirm_completion: "Confirmar finalización",
    keybox_missing_fallback: "Ningún código de caja de llaves configurado — pregunta al responsable.",
    keys_position_missing_fallback: "Ubicación de las llaves no configurada — pregunta al responsable.",
    // -- Profile --
    my_profile: "Mi perfil",
    logout: "Salir",
    email: "Email",
    role: "Rol",
    language: "Idioma",
    change_pin: "Cambiar PIN",
    // -- Reports --
    reports_title: "Incidencias",
    new_report: "Nueva incidencia",
    no_reports: "Ninguna incidencia",
    // -- Notifications --
    notifications_title: "Notificaciones",
    no_notifications: "Ninguna notificación",
    // -- Logistics --
    logistics_title: "Entregas de hoy",
    pickup: "Recogida",
    delivery: "Entrega",
    both: "Recogida+Entrega",
    // -- Common actions --
    save: "Guardar",
    close: "Cerrar",
    refresh: "Actualizar",
    history: "Historial",
    my_cleanings: "Mis limpiezas",
    today: "Hoy",
    no_cleanings_list: "Ninguna limpieza",
    entering_today: "Entran hoy",
    notes_label: "Notas",
    completed: "Completada",
    open_and_complete: "Abrir y completar",
    extra_products_hint: "Informa de productos extra usados además de los kits",
    kit_extra: "extra",
    note: "Nota",
    photos_optional: "Fotos (opcionales)",
    add_photo: "Añadir foto",
    uploading: "Subiendo…",
    send_report_btn: "Enviar incidencia",
    select_placeholder: "Selecciona…",
    describe_problem: "Describe el problema o lo que hay que informar…",
    remove_photo: "Quitar foto",
    err_select_structure: "Selecciona un alojamiento",
    err_insert_note: "Escribe una nota",
    err_wait_photos: "Espera a que suban las fotos",
    err_photo_upload: "Error al subir la foto",
    report_sent: "Incidencia enviada",
    report_queued: "Estás sin conexión: se enviará al volver online.",
    no_reports_yet: "Ninguna incidencia enviada",
    original_it: "Italiano",
    push_unsupported: "Este dispositivo/navegador no admite notificaciones.",
    push_disable: "Desactivar en este dispositivo",
    push_test: "Enviar prueba",
    push_refresh_app: "Actualizar app",
    push_title: "Notificaciones push",
    push_sub: "Actívalas para recibir en el móvil cada nueva asignación o incidencia urgente.",
    push_blocked: "Notificaciones bloqueadas por el navegador. Actívalas en los ajustes del sitio y reinténtalo.",
    push_enable: "Activar notificaciones",
    push_active: "Notificaciones activas en este móvil.",
    role_dipendente: "Empleada",
    role_responsabile: "Responsable",
    role_rider: "Repartidor",
    phone: "Teléfono",
    pin_hint: "Acceso rápido con PIN de 4 cifras. Para cambiarlo pide al Super Admin.",
    lang_updated: "Idioma actualizado",
    load_error: "Error de carga",
    no_upcoming_cleanings: "Ninguna limpieza asignada para los próximos días",
    upcoming_cleanings: "Próximas limpiezas asignadas",
    your_reports: "Tus incidencias",
    new_short: "Nueva",
    no_reports_hint: "Envía una si ves un problema en el alojamiento",
    st_aperta: "Abierta",
    st_in_lavorazione: "En curso",
    st_risolta: "Resuelta",
    st_chiusa: "Cerrada",
    updates: "Novedades",
    mark_all: "Marcar todas",
    all_marked_read: "Todas marcadas como leídas",
    dev_title: "Incidencias y desvíos del kit",
    dev_help: "Puedes enviar solo una nota al responsable (sin indicar piezas), o avisar de una pieza usada de más, no usada o para dar de baja. El almacén no se toca: decide el responsable.",
    dev_item: "Artículo",
    dev_optional: "(opcional)",
    dev_no_item: "Ningún artículo: envío solo la nota",
    dev_what_happened: "Qué ha pasado",
    dev_pieces: "Piezas",
    dev_note_ph: "Nota para el responsable (basta con esto para enviar)",
    dev_add_row: "Añadir otra línea",
    dev_submit: "Avisar al responsable",
    dev_err_empty: "Escribe una nota o elige un artículo",
    dev_sent: "Aviso enviado al responsable",
    dev_queued: "Sin red: el aviso se enviará al volver la señal",
    dev_k_usato_extra: "Pieza usada de más",
    dev_k_non_usato: "Pieza no usada",
    dev_k_storno: "Pieza no conforme (manchada/dañada)",
    dev_k_nota: "Solo aviso (ninguna pieza)",
    dev_generic: "Aviso",
    dev_pz: "uds",
    dev_pending: "pendiente",
    dev_applied: "aplicado",
    dev_ignored: "ignorado",
    st_da_fare: "Confirmada",
    st_in_viaggio: "En camino",
    st_iniziata: "Iniciada",
    st_in_corso: "En curso",
    st_completata: "Completada",
    st_bloccata: "Bloqueada",
    st_da_verificare: "Por verificar",
    tax_title: "Tasa turística",
    tax_help: "Si encuentras efectivo de la tasa turística, escribe el importe, haz la foto e indica si lo dejaste allí o lo llevas contigo. Cuando lo lleves a la oficina, márcalo.",
    tax_amount: "Importe",
    tax_photo: "Foto del efectivo",
    tax_left_there: "Lo he dejado allí",
    tax_taken: "Lo llevo conmigo",
    tax_delivered: "Entregado en la oficina",
    tax_saved: "Registrado",
    tax_err_amount: "Escribe el importe encontrado",
    tax_st_left: "en el apartamento",
    tax_st_taken: "en manos de la empleada",
  },

  en: {
    dir: "ltr",
    locale: "en-US",
    title: "Daily assignment sheet",
    for: "For",
    date: "Date",
    cleanings: "Cleanings",
    deliveries: "Deliveries",
    no_cleanings: "No cleanings today",
    no_deliveries: "No deliveries today",
    structure: "Property",
    address: "Address",
    beds: "Beds",
    matr: "Double",
    matr1p: "1.5 person",
    sing: "Single",
    guests_arriving: "GUESTS ARRIVING",
    private_linen: "Private linen",
    notes: "Notes",
    listen: "Listen",
    stop_listen: "Stop",
    keybox: "Keybox",
    keys: "Keys",
    access: "Access",
    print: "Print",
    kg: "kg",
    signature: "Signature",
    daily_sheet_tag: "Daily sheet",
    guests_total: "total guests",
    guests_short: "gst",
    guests_arriving_short: "Arriving",
    bathrooms: "Bathrooms",
    bathroom_unit: "bathroom",
    extra: "extra",
    no_bed_change: "no bed change",
    parking: "Parking",
    contact: "Contact",
    floor: "floor",
    operator_signature: "Operator signature",
    start_time: "Start time",
    end_time: "End time",
    done: "Done",
    unassigned: "Unassigned",
    operator: "Operator",
    cleanings_count: "cleanings",
    nav_today: "Today",
    nav_cleanings: "Cleanings",
    nav_reports: "Reports",
    nav_profile: "Profile",
    nav_kilo: "Kilo AI",
    nav_notifications: "Notifications",
    nav_logistics: "Logistics",
    nav_logistics_structures: "Properties",
    hello: "Hi",
    kpi_assigned: "Assigned",
    kpi_to_do: "To start",
    kpi_in_progress: "In progress",
    kpi_completed: "Completed",
    call_responsible: "Call manager",
    call_responsible_sub: "For issues or emergencies",
    today_cleanings: "Today's cleanings",
    no_cleanings_today: "No cleanings today",
    no_cleanings_today_sub: "Rest or check tomorrow.",
    guest_one: "guest",
    guest_many: "guests",
    bed_double: "double",
    bed_double_1p: "double (1 person)",
    bed_single: "single",
    back: "Back",
    have_problem: "Got a problem?",
    send_report: "Send a report with photo",
    report_action: "Report →",
    info: "Information",
    keys_position: "Key location",
    beds_planned: "Beds planned",
    contacts: "Contacts",
    access_notes: "Access notes",
    kits_planned: "Planned kits",
    day_note: "Daily note",
    fixed_note: "Fixed note for this house",
    linen_in_house: "Linen in the house",

    start_cleaning: "Start cleaning",
    complete_cleaning: "Complete cleaning",
    cleaning_completed: "Cleaning completed",
    kits_used: "Kits used",
    signature_full_name: "Signature (full name)",
    signature_placeholder: "e.g. John Smith",
    final_notes: "Final notes",
    cancel: "Cancel",
    sending: "Sending…",
    confirm_completion: "Confirm completion",
    keybox_missing_fallback: "No keybox code set — ask the manager.",
    keys_position_missing_fallback: "Key location not set — ask the manager.",
    my_profile: "My profile",
    logout: "Log out",
    email: "Email",
    role: "Role",
    language: "Language",
    change_pin: "Change PIN",
    reports_title: "Reports",
    new_report: "New report",
    no_reports: "No reports",
    notifications_title: "Notifications",
    no_notifications: "No notifications",
    logistics_title: "Today's deliveries",
    pickup: "Pickup",
    delivery: "Delivery",
    both: "Pickup + Delivery",
    save: "Save",
    close: "Close",
    refresh: "Refresh",
    history: "History",
    my_cleanings: "My cleanings",
    today: "Today",
    no_cleanings_list: "No cleanings",
    entering_today: "Arriving today",
    notes_label: "Notes",
    completed: "Completed",
    open_and_complete: "Open and complete",
    extra_products_hint: "Report extra products used beyond the kits",
    kit_extra: "extra",
    note: "Note",
    photos_optional: "Photos (optional)",
    add_photo: "Add photo",
    uploading: "Uploading…",
    send_report_btn: "Send report",
    select_placeholder: "Select…",
    describe_problem: "Describe the problem or what needs reporting…",
    remove_photo: "Remove photo",
    err_select_structure: "Select a property",
    err_insert_note: "Write a note",
    err_wait_photos: "Wait for the photos to upload",
    err_photo_upload: "Photo upload failed",
    report_sent: "Report sent",
    report_queued: "You are offline: the report will be sent when you are back online.",
    no_reports_yet: "No reports sent",
    original_it: "Italian",
    push_unsupported: "This device/browser does not support notifications.",
    push_disable: "Turn off on this device",
    push_test: "Send test",
    push_refresh_app: "Update app",
    push_title: "Push notifications",
    push_sub: "Turn on to get every new assignment or urgent report on your phone.",
    push_blocked: "Notifications blocked by the browser. Enable them in the site settings and try again.",
    push_enable: "Enable notifications",
    push_active: "Notifications active on this phone.",
    role_dipendente: "Cleaner",
    role_responsabile: "Manager",
    role_rider: "Rider",
    phone: "Phone",
    pin_hint: "Quick access with a 4-digit PIN. Ask the Super Admin to change it.",
    lang_updated: "Language updated",
    load_error: "Loading error",
    no_upcoming_cleanings: "No cleanings assigned for the coming days",
    upcoming_cleanings: "Upcoming assigned cleanings",
    your_reports: "Your reports",
    new_short: "New",
    no_reports_hint: "Send one if you notice a problem in the property",
    st_aperta: "Open",
    st_in_lavorazione: "In progress",
    st_risolta: "Solved",
    st_chiusa: "Closed",
    updates: "Updates",
    mark_all: "Mark all",
    all_marked_read: "All marked as read",
    dev_title: "Reports and kit deviations",
    dev_help: "You can send just a note to the manager (without listing items), or report an item used extra, not used or to write off. Stock is not changed: the manager decides.",
    dev_item: "Item",
    dev_optional: "(optional)",
    dev_no_item: "No item: sending just the note",
    dev_what_happened: "What happened",
    dev_pieces: "Pieces",
    dev_note_ph: "Note for the manager (this alone is enough to send)",
    dev_add_row: "Add another line",
    dev_submit: "Report to manager",
    dev_err_empty: "Write a note or pick an item",
    dev_sent: "Reported to the manager",
    dev_queued: "No network: the report will be sent when the signal is back",
    dev_k_usato_extra: "Item used extra",
    dev_k_non_usato: "Item not used",
    dev_k_storno: "Non-compliant item (stained/damaged)",
    dev_k_nota: "Report only (no item)",
    dev_generic: "Report",
    dev_pz: "pcs",
    dev_pending: "pending",
    dev_applied: "applied",
    dev_ignored: "ignored",
    st_da_fare: "To do",
    st_in_viaggio: "On the way",
    st_iniziata: "Started",
    st_in_corso: "In progress",
    st_completata: "Completed",
    st_bloccata: "Blocked",
    st_da_verificare: "To check",
    tax_title: "City tax",
    tax_help: "If you find city tax cash in the apartment, write the amount, take a photo and say whether you left it there or took it with you. Mark it when you bring it to the office.",
    tax_amount: "Amount",
    tax_photo: "Photo of the cash",
    tax_left_there: "I left it there",
    tax_taken: "I took it with me",
    tax_delivered: "Handed in at the office",
    tax_saved: "Recorded",
    tax_err_amount: "Write the amount you found",
    tax_st_left: "in the apartment",
    tax_st_taken: "with the cleaner",
  },
  ur: {
    dir: "rtl",
    locale: "ur-PK",
    title: "روزانہ کام کی فہرست",
    for: "برائے",
    date: "تاریخ",
    cleanings: "صفائی",
    deliveries: "ترسیلات",
    no_cleanings: "آج کوئی صفائی نہیں",
    no_deliveries: "آج کوئی ترسیل نہیں",
    structure: "جائیداد",
    address: "پتہ",
    beds: "بستر",
    matr: "ڈبل",
    matr1p: "ڈیڑھ",
    sing: "سنگل",
    guests_arriving: "مہمان آج آ رہے ہیں",
    private_linen: "ذاتی چادریں",
    notes: "نوٹس",
    listen: "سنیں",
    stop_listen: "روکیں",
    keybox: "چابی کا خانہ",
    keys: "چابیاں",
    access: "رسائی",
    print: "پرنٹ کریں",
    kg: "کلو",
    signature: "دستخط",
    daily_sheet_tag: "روزانہ فہرست",
    guests_total: "کل مہمان",
    guests_short: "مہ.",
    guests_arriving_short: "آ رہے ہیں",
    bathrooms: "غسل خانے",
    bathroom_unit: "غسل خانہ",
    extra: "اضافی",
    no_bed_change: "بستر تبدیل نہیں",
    parking: "پارکنگ",
    contact: "رابطہ",
    floor: "منزل",
    operator_signature: "دستخط عملہ",
    start_time: "شروع کا وقت",
    end_time: "اختتام کا وقت",
    done: "مکمل",
    unassigned: "غیر تفویض",
    operator: "عملہ",
    cleanings_count: "صفائیاں",
    nav_today: "آج",
    nav_cleanings: "صفائیاں",
    nav_reports: "شکایات",
    nav_profile: "پروفائل",
    nav_kilo: "کِلو AI",
    nav_notifications: "اطلاعات",
    nav_logistics: "لاجسٹکس",
    nav_logistics_structures: "جائیدادیں",
    hello: "سلام",
    kpi_assigned: "تفویض شدہ",
    kpi_to_do: "شروع کرنا ہے",
    kpi_in_progress: "جاری",
    kpi_completed: "مکمل",
    call_responsible: "منیجر کو کال کریں",
    call_responsible_sub: "کسی مسئلہ یا ہنگامی صورت میں",
    today_cleanings: "آج کی صفائیاں",
    no_cleanings_today: "آج کوئی صفائی نہیں",
    no_cleanings_today_sub: "آرام کریں یا کل چیک کریں۔",
    guest_one: "مہمان",
    guest_many: "مہمان",
    bed_double: "ڈبل بیڈ",
    bed_double_1p: "ڈبل (1 فرد)",
    bed_single: "سنگل بیڈ",
    back: "واپس",
    have_problem: "کوئی مسئلہ ہے؟",
    send_report: "تصویر کے ساتھ شکایت بھیجیں",
    report_action: "شکایت →",
    info: "معلومات",
    keys_position: "چابیوں کی جگہ",
    beds_planned: "طے شدہ بستر",
    contacts: "رابطے",
    access_notes: "رسائی نوٹس",
    kits_planned: "طے شدہ کِٹس",
    day_note: "آج کا نوٹ",
    fixed_note: "گھر کا مستقل نوٹ",
    start_cleaning: "صفائی شروع کریں",
    linen_in_house: "گھر میں موجود بستر/تولیے",

    complete_cleaning: "صفائی مکمل کریں",
    cleaning_completed: "صفائی مکمل ہو گئی",
    kits_used: "استعمال شدہ کِٹس",
    signature_full_name: "دستخط (پورا نام)",
    signature_placeholder: "مثال: احمد علی",
    final_notes: "حتمی نوٹس",
    cancel: "منسوخ",
    sending: "بھیجا جا رہا ہے…",
    confirm_completion: "تکمیل کی تصدیق کریں",
    keybox_missing_fallback: "کوئی چابی کوڈ سیٹ نہیں — منیجر سے پوچھیں۔",
    keys_position_missing_fallback: "چابی کی جگہ سیٹ نہیں — منیجر سے پوچھیں۔",
    my_profile: "میرا پروفائل",
    logout: "لاگ آؤٹ",
    email: "ای میل",
    role: "کردار",
    language: "زبان",
    change_pin: "پن تبدیل کریں",
    reports_title: "شکایات",
    new_report: "نئی شکایت",
    no_reports: "کوئی شکایت نہیں",
    notifications_title: "اطلاعات",
    no_notifications: "کوئی اطلاع نہیں",
    logistics_title: "آج کی ترسیلات",
    pickup: "اٹھانا",
    delivery: "پہنچانا",
    both: "اٹھانا + پہنچانا",
    save: "محفوظ کریں",
    close: "بند کریں",
    refresh: "تازہ کریں",
    history: "تاریخچہ",
    my_cleanings: "میری صفائیاں",
    today: "آج",
    no_cleanings_list: "کوئی صفائی نہیں",
    entering_today: "مہمان آج آ رہے ہیں",
    notes_label: "نوٹس",
    completed: "مکمل ہو گئی",
    open_and_complete: "کھولیں اور مکمل کریں",
    extra_products_hint: "کِٹ کے علاوہ استعمال ہونے والی اضافی اشیاء بتائیں",
    kit_extra: "اضافی",
    note: "نوٹ",
    photos_optional: "تصاویر (اختیاری)",
    add_photo: "تصویر شامل کریں",
    uploading: "اپ لوڈ ہو رہا ہے…",
    send_report_btn: "شکایت بھیجیں",
    select_placeholder: "منتخب کریں…",
    describe_problem: "مسئلہ یا جو بتانا ہے وہ لکھیں…",
    remove_photo: "تصویر ہٹائیں",
    err_select_structure: "جائیداد منتخب کریں",
    err_insert_note: "نوٹ لکھیں",
    err_wait_photos: "تصاویر اپ لوڈ ہونے کا انتظار کریں",
    err_photo_upload: "تصویر اپ لوڈ نہیں ہو سکی",
    report_sent: "شکایت بھیج دی گئی",
    report_queued: "آپ آف لائن ہیں: انٹرنیٹ آنے پر شکایت بھیج دی جائے گی۔",
    no_reports_yet: "کوئی شکایت نہیں بھیجی گئی",
    original_it: "اطالوی",
    push_unsupported: "یہ ڈیوائس/براؤزر اطلاعات کی سہولت نہیں دیتا۔",
    push_disable: "اس ڈیوائس پر بند کریں",
    push_test: "ٹیسٹ بھیجیں",
    push_refresh_app: "ایپ اپ ڈیٹ کریں",
    push_title: "پش اطلاعات",
    push_sub: "فون پر ہر نئی تفویض یا ضروری شکایت پانے کے لیے آن کریں۔",
    push_blocked: "براؤزر نے اطلاعات بلاک کر دی ہیں۔ سائٹ کی سیٹنگز میں اجازت دیں اور دوبارہ کوشش کریں۔",
    push_enable: "اطلاعات آن کریں",
    push_active: "اس فون پر اطلاعات آن ہیں۔",
    role_dipendente: "ملازمہ",
    role_responsabile: "منیجر",
    role_rider: "رائیڈر",
    phone: "فون",
    pin_hint: "4 ہندسوں کے پن سے لاگ اِن۔ پن بدلوانے کے لیے سپر ایڈمن سے کہیں۔",
    lang_updated: "زبان تبدیل ہو گئی",
    load_error: "لوڈنگ میں خرابی",
    no_upcoming_cleanings: "آنے والے دنوں کے لیے کوئی صفائی تفویض نہیں",
    upcoming_cleanings: "آنے والی تفویض شدہ صفائیاں",
    your_reports: "آپ کی شکایات",
    new_short: "نئی",
    no_reports_hint: "اگر جائیداد میں کوئی مسئلہ نظر آئے تو بھیجیں",
    st_aperta: "کھلی",
    st_in_lavorazione: "جاری",
    st_risolta: "حل ہو گئی",
    st_chiusa: "بند",
    updates: "تازہ اطلاعات",
    mark_all: "سب پڑھی ہوئی",
    all_marked_read: "سب کو پڑھا ہوا نشان لگا دیا",
    dev_title: "شکایات اور کِٹ میں فرق",
    dev_help: "آپ صرف منیجر کو نوٹ بھیج سکتی ہیں (کوئی چیز بتائے بغیر)، یا بتا سکتی ہیں کہ کوئی چیز زیادہ استعمال ہوئی، استعمال نہیں ہوئی یا خراب ہو گئی۔ اسٹاک تبدیل نہیں ہوتا: فیصلہ منیجر کرتا ہے۔",
    dev_item: "چیز",
    dev_optional: "(اختیاری)",
    dev_no_item: "کوئی چیز نہیں: صرف نوٹ بھیجیں",
    dev_what_happened: "کیا ہوا",
    dev_pieces: "تعداد",
    dev_note_ph: "منیجر کے لیے نوٹ (صرف یہی کافی ہے)",
    dev_add_row: "ایک اور سطر شامل کریں",
    dev_submit: "منیجر کو بتائیں",
    dev_err_empty: "نوٹ لکھیں یا کوئی چیز منتخب کریں",
    dev_sent: "منیجر کو بتا دیا گیا",
    dev_queued: "انٹرنیٹ نہیں: سگنل آنے پر بھیج دیا جائے گا",
    dev_k_usato_extra: "چیز زیادہ استعمال ہوئی",
    dev_k_non_usato: "چیز استعمال نہیں ہوئی",
    dev_k_storno: "خراب چیز (داغ/ٹوٹی)",
    dev_k_nota: "صرف اطلاع (کوئی چیز نہیں)",
    dev_generic: "اطلاع",
    dev_pz: "عدد",
    dev_pending: "زیرِ التوا",
    dev_applied: "لاگو",
    dev_ignored: "نظرانداز",
    st_da_fare: "کرنا ہے",
    st_in_viaggio: "راستے میں",
    st_iniziata: "شروع",
    st_in_corso: "جاری",
    st_completata: "مکمل",
    st_bloccata: "رُکی ہوئی",
    st_da_verificare: "جانچنا ہے",
    tax_title: "سٹی ٹیکس",
    tax_help: "اگر اپارٹمنٹ میں سٹی ٹیکس کی نقدی ملے تو رقم لکھیں، تصویر لیں اور بتائیں کہ وہیں چھوڑی یا ساتھ لی۔ دفتر لانے پر نشان لگائیں۔",
    tax_amount: "رقم",
    tax_photo: "نقدی کی تصویر",
    tax_left_there: "وہیں چھوڑ دی",
    tax_taken: "ساتھ لے لی",
    tax_delivered: "دفتر میں جمع کرا دی",
    tax_saved: "درج ہو گیا",
    tax_err_amount: "ملنے والی رقم لکھیں",
    tax_st_left: "اپارٹمنٹ میں",
    tax_st_taken: "ملازمہ کے پاس",
  },
};

export function t(lang, key) {
  return (LANG[lang] || LANG.it)[key] || key;
}

/** Formatta una data YYYY-MM-DD nel formato lungo della lingua indicata. */
export function formatDateLongI18n(dateStr, lang) {
  const locale = (LANG[lang] || LANG.it).locale || "it-IT";
  try {
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString(locale, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  } catch { return dateStr; }
}

/** Ritorna "Italiano · Traduzione" se lang != 'it', altrimenti solo italiano.
 *  Con `onlyTranslation` ritorna solo la traduzione (fallback italiano se manca). */
export function bilingual(lang, key, onlyTranslation = false) {
  const it = (LANG.it[key] || key);
  if (!lang || lang === "it") return it;
  const tr = (LANG[lang] || {})[key];
  if (!tr || tr === it) return it;
  return onlyTranslation ? tr : `${it} · ${tr}`;
}

/** Direzione del testo della lingua (ltr/rtl). */
export function langDir(lang) {
  return (LANG[lang] || LANG.it).dir || "ltr";
}
